'use client'
import { envs } from '@config'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { usePathname, useRouter } from 'next/navigation'
import { PropsWithChildren, ReactElement, useEffect } from 'react'

import { AuthHandler } from '../../utils'

const REDIRECT_PATH = '/sign-in'
const PUBLICS_PATH = ['/sign-in', '/sign-in-test']

export default function AuthProvider({
  children,
}: PropsWithChildren): ReactElement {
  const router = useRouter()
  const pathname = usePathname()

  useEffect(
    function authGuardianHandler() {
      const path = pathname
      const isOnAPublicRoute = PUBLICS_PATH.includes(path)

      const redirectToLoginScreen =
        !AuthHandler.isAuthenticated && !isOnAPublicRoute

      if (redirectToLoginScreen) {
        router.push(REDIRECT_PATH)
      }
    },
    [pathname, router]
  )

  return (
    <GoogleOAuthProvider
      clientId={envs.googleClientId}
      // eslint-disable-next-line no-console
      onScriptLoadError={console.log}
      // eslint-disable-next-line no-console
      onScriptLoadSuccess={console.log}
    >
      {children}
    </GoogleOAuthProvider>
  )
}
